/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type Facet = typeof Facet[keyof typeof Facet];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Facet = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  quarterly: 'quarterly',
  yearly: 'yearly',
  agency: 'agency',
  topic: 'topic',
  section: 'section',
  type: 'type',
  subtype: 'subtype',
} as const;
